<template>
  <div class="page">
    <nav-bar
      title="添加预约"
      left-text="返回"
      left-arrow
      @click-left="goBack"
      :fixed="true"
      :placeholder="true"
    />
    <div class="no-items" v-if="items.length == 0">
      <div class="text" @click="toSelectGoods">+ 添加服务项目或者产品</div>
    </div>
    <div class="good-wrapper" v-else>
      <div class="item" v-for="(item, index) in items" :key="index">
        <div class="picture">
          <img :src="item.itemPic + '!tmb_130'" v-if="item.itemPic" />
          <img src="@assets/images/def_service.jpg" class="no-pictrue" v-else />
        </div>
        <div class="text">
          <div class="attr title">
            <div class="name line1">{{ item.itemName }}</div>
            <div class="money">￥{{ item.price }}</div>
          </div>
        </div>
        <div class="tools" @click="removeItem(index)">
          <i class="iconfont icon-guanbi3"></i>
        </div>
      </div>
    </div>

    <vant-form>
      <div class="panel">
        <div class="title">预约日期</div>
        <div class="timer-page">
          <div class="header">
            <div
              class="time-item"
              :class="activeTime == 0 ? 'active' : ''"
              @click="switchDate(0)"
            >
              <div class="week">{{ weekName[today.getDay()] }}</div>
              <div class="date">{{ dayjs().format("MM-DD") }}</div>
            </div>
            <div
              class="time-item"
              :class="activeTime == 1 ? 'active' : ''"
              @click="switchDate(1)"
            >
              <div class="week">
                {{
                  weekName[
                    today.getDay() + 1 >= 7
                      ? 6 - today.getDay()
                      : today.getDay() + 1
                  ]
                }}
              </div>
              <div class="date">
                {{ dayjs().add(1, "day").format("MM-DD") }}
              </div>
            </div>
            <div
              class="time-item"
              :class="activeTime == 2 ? 'active' : ''"
              @click="switchDate(2)"
            >
              <div class="week">
                {{
                  weekName[
                    today.getDay() + 2 >= 7
                      ? today.getDay() - 5
                      : today.getDay() + 2
                  ]
                }}
              </div>
              <div class="date">
                {{ dayjs().add(2, "day").format("MM-DD") }}
              </div>
            </div>
            <div
              class="time-item"
              :class="activeTime == 3 ? 'active' : ''"
              @click="switchDate(3)"
            >
              <div class="week">
                {{
                  weekName[
                    today.getDay() + 3 >= 7
                      ? today.getDay() - 4
                      : today.getDay() + 3
                  ]
                }}
              </div>
              <div class="date">
                {{ dayjs().add(3, "day").format("MM-DD") }}
              </div>
            </div>
            <div
              class="time-item"
              :class="activeTime == 4 ? 'active' : ''"
              @click="switchDate(4)"
            >
              <div class="week">
                {{
                  weekName[
                    today.getDay() + 4 >= 7
                      ? today.getDay() - 3
                      : today.getDay() + 4
                  ]
                }}
              </div>
              <div class="date">
                {{ dayjs().add(4, "day").format("MM-DD") }}
              </div>
            </div>
            <div
              class="time-item"
              :class="activeTime == 5 ? 'active' : ''"
              @click="switchDate(5)"
            >
              <div class="week">
                {{
                  weekName[
                    today.getDay() + 5 >= 7
                      ? today.getDay() - 2
                      : today.getDay() + 5
                  ]
                }}
              </div>
              <div class="date">
                {{ dayjs().add(5, "day").format("MM-DD") }}
              </div>
            </div>
          </div>

          <div class="body">
            <template v-for="solt in timeArray">
              <div
                :class="[{ active: isActive(solt) }, 'item']"
                @click="switchSolt(solt)"
                :key="solt"
                v-if="!isPast(solt) && !isBeyond(solt)"
              >
                <div class="time">{{ formatSolt(solt) }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="panel">
        <div class="title">
          选择技师
          <span class="recommend-btn" @click="doRecommend">智能排位</span>
        </div>
        <div class="waiter-page">
          <div
            :class="[{ active: isActiveWaiter(waiter) }, 'item']"
            @click="switchWaiter(waiter)"
            v-for="waiter in waiterList"
            :key="waiter.id"
          >
            <img class="avator" :src="waiter.picture" v-if="waiter.picture" />
            <img class="avator" src="@assets/images/avator.jpg" v-else />
            <div class="user">{{ waiter.trueName }}</div>
          </div>
        </div>
      </div>

      <cell-group title="">
        <field
          label="留言信息"
          v-model="info.notes"
          rows="3"
          autosize
          type="textarea"
          placeholder="请输入留言"
        />
      </cell-group>

      <div style="margin: 16px">
        <vant-button
          round
          block
          type="info"
          @click="savePlan"
          color="#f06357"
          :loading="loading"
          >{{ idEdit ? "确认改约" : "确认预约" }}</vant-button
        >
      </div>
    </vant-form>
    <goods-selector :visible="showGoods" @done="handleGoods"></goods-selector>

    <!-- 智能排位候选弹层 -->
    <vant-popup
      v-model="showRecommend"
      position="bottom"
      get-container="#app"
      :style="{ height: '60vh' }"
      round
    >
      <div class="recommend-page">
        <div class="recommend-title">可用时段（最早优先）</div>
        <div class="recommend-list">
          <div
            class="recommend-item"
            v-for="(item, idx) in recommendList"
            :key="idx"
            @click="pickRecommend(item)"
          >
            <span class="tech">{{ item.techName || "任意技师" }}</span>
            <span class="slot"
              >{{ minToLabel(item.startMin) }}-{{
                minToLabel(item.endMin)
              }}</span
            >
          </div>
          <div class="no-recommend" v-if="recommendList.length === 0">
            暂无可用时段，请更换日期或项目
          </div>
        </div>
      </div>
    </vant-popup>
  </div>
</template>

<script>
import {
  NavBar,
  Toast,
  Button as VantButton,
  Form as VantForm,
  CellGroup,
  Field,
  Popup as VantPopup,
} from "vant";
import GoodsSelector from "@views/selector/GoodsSelector";
import {
  save,
  reschedule,
  validate,
  recommend,
  get,
  fetchBusinessHour,
} from "@api/plan";
import { fetchByShop } from "@api/shop";
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  components: {
    Field,
    CellGroup,
    NavBar,
    VantForm,
    VantButton,
    VantPopup,
    GoodsSelector,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    idEdit() {
      return this.$route.query.id;
    },
    // 已选项目总时长（分钟），endMin = startMin + totalDuration
    totalDuration() {
      return this.items.reduce((s, i) => s + (i.elapsed || 30), 0);
    },
  },
  mounted() {
    let that = this;
    // 添加返回事件监听
    window.addEventListener(
      "popstate",
      function () {
        that.showGoods = false;
      },
      false
    );
  },
  watch: {
    showGoods: function (newVal) {
      if (newVal === true) {
        this.pushHistory();
      }
    },
  },
  created() {
    this.init();
    this.loadBusinessHour();
    this.fetchWaiter();
    if (this.idEdit) this.getEcho();
  },
  data: function () {
    return {
      items: [],
      loading: false,
      showGoods: false,
      info: {},
      dayjs,
      activeTime: 0,
      activeSolt: null, // 单选起始格分钟数
      waiterList: [],
      // 9:00-18:00 半小时粒度默认值（分钟数，540=9:00），进入页面后按门店营业时段配置重建
      timeArray: [
        540, 570, 600, 630, 660, 690, 720, 750, 780, 810, 840, 870, 900, 930,
        960, 990, 1020, 1050,
      ],
      // 营业结束分钟数（排他），用于过滤超出打烊时间的格
      closeMin: 1080,
      weekName: [
        "周天",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
        "周天",
      ],
      today: new Date(),
      // 智能排位
      showRecommend: false,
      recommendList: [],
    };
  },
  methods: {
    init() {
      this.info.accountId = this.userInfo.id;
      this.info.accountName = this.userInfo.trueName;
      this.info.phone = this.userInfo.phone;
      this.info.shopId = this.userInfo.shopId;
      this.info.companyId = this.userInfo.companyId;
      this.info.shopName = this.userInfo.shopName;
      this.info.createdBy = this.userInfo.id;
    },
    getEcho() {
      // 改约回显
      get(this.idEdit).then((res) => {
        const plan = res.result || {};
        this.info = { ...this.info, ...plan };
        this.items = plan.itemList || [];
        // 回显技师选中态、日期选中态
        if (plan.planDate) {
          const diff = dayjs(plan.planDate)
            .startOf("day")
            .diff(dayjs().startOf("day"), "day");
          if (diff >= 0 && diff <= 5) this.activeTime = diff;
        }
        if (plan.startMin != null) this.activeSolt = plan.startMin;
      });
    },
    minToLabel(m) {
      if (m == null) return "";
      const h = Math.floor(m / 60)
        .toString()
        .padStart(2, "0");
      const mm = (m % 60).toString().padStart(2, "0");
      return `${h}:${mm}`;
    },
    isPast(min) {
      // 当天该分钟数时间点是否已过（仅当天 activeTime=0 时需要过滤）
      const day = dayjs()
        .add(this.activeTime, "day")
        .set("hour", Math.floor(min / 60))
        .set("minute", min % 60)
        .set("second", 0);
      return day.valueOf() < dayjs().valueOf();
    },
    isBeyond(min) {
      // 起始格加项目总时长超出营业结束时间（排他 closeMin）不可选
      return min + (this.totalDuration || 30) > this.closeMin;
    },
    loadBusinessHour() {
      // 读取门店营业时段配置（后端无配置返回默认 540/1080），重建时段网格，替代硬编码
      if (!this.info.shopId) return;
      fetchBusinessHour(this.info.shopId)
        .then((res) => {
          const bh = res.result || {};
          if (bh.openMin != null && bh.closeMin != null) {
            const arr = [];
            for (let m = bh.openMin; m < bh.closeMin; m += 30) arr.push(m);
            this.timeArray = arr;
            this.closeMin = bh.closeMin;
          }
        })
        .catch(() => {});
    },
    formatSolt(min) {
      // 返回 09:00 起，时长 totalDuration，如 09:00-10:00
      const end = min + (this.totalDuration || 30);
      return `${this.minToLabel(min)}-${this.minToLabel(end)}`;
    },
    switchDate(idx) {
      this.activeTime = idx;
      this.activeSolt = null;
    },
    switchSolt: function (solt) {
      // 单选起始格，endMin 由 totalDuration 计算
      this.activeSolt = solt;
    },
    isActive: function (solt) {
      if (this.activeSolt == null) return false;
      const end = this.activeSolt + (this.totalDuration || 30);
      return solt >= this.activeSolt && solt < end;
    },
    switchWaiter: function (waiter) {
      this.info.waiterId = waiter.id;
      this.info.waiterName = waiter.trueName;
      this.$forceUpdate();
    },
    isActiveWaiter: function (waiter) {
      return this.info.waiterId === waiter.id;
    },
    fetchWaiter() {
      // 查询门店全部技师，时段冲突在提交前由 validate 预检
      fetchByShop(this.info.shopId).then((res) => {
        this.waiterList = res.result || [];
      });
    },
    doRecommend() {
      if (this.items.length === 0) {
        return Toast("请先选择服务项目！");
      }
      const planDate = dayjs().add(this.activeTime, "day").format("YYYY-MM-DD");
      Toast.loading({ duration: 0, forbidClick: true, message: "查询中..." });
      recommend({
        shopId: this.info.shopId,
        date: planDate,
        totalDuration: this.totalDuration,
        techId: this.info.waiterId || undefined,
      })
        .then((res) => {
          Toast.clear();
          this.recommendList = res.result || [];
          this.showRecommend = true;
        })
        .catch(() => {
          Toast.clear();
        });
    },
    pickRecommend(item) {
      // 回填技师 + 时段
      if (item.techId) {
        this.info.waiterId = item.techId;
        this.info.waiterName = item.techName;
      }
      this.activeSolt = item.startMin;
      this.showRecommend = false;
    },
    pushHistory() {
      // 修改history：仅为了让物理返回键先关闭弹窗。
      // url 必须用当前路由路径，不能用随便填的值——
      // 否则该记录泄漏到 history 后，用户点返回会命中 404 通配路由
      var state = {
        title: "",
        url: this.$route.fullPath,
      };
      window.history.pushState(state, state.title, state.url);
    },
    toSelectGoods() {
      this.showGoods = true;
    },
    savePlan() {
      if (!this.info.waiterId) {
        return Toast("选择服务老师！");
      }
      if (this.items.length == 0) {
        return Toast("选择服务项目！");
      }
      if (this.activeSolt == null) {
        return Toast("选择预约时间！");
      }

      const planDate = dayjs().add(this.activeTime, "day").format("YYYY-MM-DD");
      const startMin = this.activeSolt;
      const endMin = startMin + this.totalDuration;

      Toast.loading({ duration: 0, forbidClick: true, message: "提交中..." });

      // 提交前冲突预检（技师 + 时段），改约场景排除自身
      validate({
        techId: this.info.waiterId,
        date: planDate,
        startMin: startMin,
        endMin: endMin,
        excludePlanId: this.idEdit || undefined,
      })
        .then((vres) => {
          const conflict = vres.result || {};
          if (conflict.techConflict && conflict.techConflict.length > 0) {
            Toast.clear();
            return Toast("该技师该时段已被占用，请更换");
          }
          if (conflict.scheduleConflict) {
            Toast.clear();
            return Toast("该技师当日未排班，请更换");
          }
          this.doSave(planDate, startMin, endMin);
        })
        .catch(() => {
          // 预检失败（接口异常等）不阻断，仍提交由后端兜底
          this.doSave(planDate, startMin, endMin);
        });
    },
    doSave(planDate, startMin, endMin) {
      this.info.planDate = planDate;
      this.info.startMin = startMin;
      this.info.endMin = endMin;
      this.info.items = this.items;
      const req = this.idEdit
        ? reschedule(this.idEdit, {
            planDate: planDate,
            startMin: startMin,
            endMin: endMin,
            waiterId: this.info.waiterId,
            waiterName: this.info.waiterName,
          })
        : save(this.info);
      req
        .then((res) => {
          Toast(res.message || "提交成功");
          Toast.clear();
          this.$router.replace({ path: "/user/plan" });
        })
        .catch(() => {
          Toast.clear();
        });
    },
    handleGoods(item) {
      if (item) {
        this.items = [item];
      }

      this.showGoods = false;
      this.$router.back(); // 将添加记录从history中移除
    },
    removeItem(idx) {
      this.items.splice(idx, 1);
    },
    goBack() {
      if (this.showGoods) {
        this.showGoods = false;
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  background-color: #f7f7f7;
  padding: 0 12px;

  .no-items {
    background-color: #ffffff;
    margin-top: 12px;
    border-radius: 4px;
    padding: 10px 15px;

    .text {
      font-size: 14px;
      border: 1px dashed #cccccc;
      padding: 12px 0;
      text-align: center;
      color: #999999;
      border-radius: 4px;
    }
  }
  .panel {
    background-color: #fff;
    margin-top: 12px;
    border-radius: 4px;
    .title {
      height: 45px;
      line-height: 45px;
      font-weight: 700;
      border-bottom: 1px solid #ebedf0;
      padding-left: 15px;
    }
  }

  .good-wrapper {
    background-color: #fff;
    margin-top: 12px;
    padding: 10px 15px;

    .item {
      display: flex;

      .picture {
        height: 50px;
        width: 50px;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          background: #f4f4f4;
        }
      }
      .text {
        flex: 1;
        font-size: 12px;
        margin-top: 5px;
        .name {
          color: #333333;
          font-size: 14px;
        }
        .money {
          margin-top: 5px;
          color: #cccccc;
          color: #e93323;
        }
      }
      .tools {
        font-size: 12px;
      }
    }
  }
}

.timer-page {
  background-color: #ffffff;
  color: #666666;
  .header {
    display: flex;
    background-color: #fff;
    align-items: center;
    border-bottom: 1px solid #ebedf0;

    .time-item {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      flex: 1;
      padding: 5px 8px;
      text-align: center;
      height: 65px;
      font-size: 13px;

      &.active {
        color: #ff4c48;
        font-weight: 700;
      }
    }
  }

  .body {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px 5px;
    box-sizing: border-box;

    .item {
      display: flex;
      width: 110px;
      text-align: center;
      justify-content: center;
      padding: 0 10px;
      height: 32px;
      line-height: 32px;
      border: 1px solid #cccccc;
      border-radius: 2px;
      margin-bottom: 10px;
      font-size: 13px;
      &.active {
        color: #ff4c48;
        border: 1px solid #ff4c48;
      }
      &.disabled {
        color: #ccc;
        background-color: #f2f2f2;
        border: 1px solid #f2f2f2;
      }
      &:not(:nth-child(3n)) {
        margin-right: calc(3% / 2);
      }
      .text {
        font-size: 12px;
      }
    }
  }
}

.waiter-page {
  background-color: #fff;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding: 20px 15px 10px;
  box-sizing: border-box;
  min-height: 100px;

  .item {
    height: 60px;
    border: 1px solid #cccccc;
    border-radius: 2px;
    margin-bottom: 10px;
    width: 155px;
    display: flex;
    justify-content: left;
    align-items: center;
    padding: 14px 10px 14px 0;
    box-sizing: border-box;

    .avator {
      width: 45px;
      height: 45px;
      border-radius: 45px;
      margin-right: 10px;
      margin-left: 15px;
    }
    &.active {
      color: #ff4c48;
      border: 1px solid #ff4c48;
    }
    &:not(:nth-child(2n)) {
      margin-right: calc(2% / 1);
    }
  }
}

.recommend-btn {
  float: right;
  font-size: 12px;
  color: #ff4c48;
  font-weight: 400;
  margin-right: 15px;
}

.recommend-page {
  padding: 15px;

  .recommend-title {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .recommend-list {
    max-height: 50vh;
    overflow-y: auto;
  }
  .recommend-item {
    display: flex;
    justify-content: space-between;
    padding: 12px 15px;
    border: 1px solid #ebedf0;
    border-radius: 4px;
    margin-bottom: 10px;
    font-size: 13px;
    color: #333;
    .tech {
      color: #666;
    }
    .slot {
      color: #ff4c48;
      font-weight: 600;
    }
  }
  .no-recommend {
    text-align: center;
    color: #999;
    padding: 30px 0;
    font-size: 13px;
  }
}
</style>
